import { useEffect } from "react";
import { Link } from "react-router-dom";

export function NotFound() {
  useEffect(() => {
    document.title = "Page not found — Odingard";
  }, []);

  return (
    <main className="page" id="main">
      <section className="page__hero">
        <p className="page__eyebrow">404</p>
        <h1>We can&rsquo;t find that page</h1>
        <p className="page__lede">
          The link may be out of date. Try the{" "}
          <Link to="/products">product portfolio</Link> or the{" "}
          <Link to="/sitemap">sitemap</Link>.
        </p>
      </section>
    </main>
  );
}
